import encore from "../img/logos/exit/Encore-Alert.jpg";
import avizia from "../img/logos/exit/avizia.jpg";
import interfolio from "../img/logos/exit/interfolio.jpg";
import trackoff from "../img/logos/exit/trackoff.png";
import cybersponse from "../img/logos/exit/cybersponse.png";

export default [
    encore, avizia, interfolio, trackoff, cybersponse
];